import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { localizePath } from "../../utils/localePaths";
import { isNonLocalizedPath } from "../../configs/nonLocalizedRoutes";

/**
 * Drop-in replacement for react-router's Link that keeps the current
 * locale prefix on internal navigation, e.g. clicking a nav link while
 * on /es/pricing lands on /es/features instead of dropping to English.
 *
 * English-only routes (see nonLocalizedRoutes) are never prefixed — a link to
 * /security stays /security even while browsing in Spanish, so we don't create
 * crawlable /es/security phantom URLs that only exist in English.
 */
export const LocaleLink = ({ to, ...props }) => {
  const { i18n } = useTranslation();
  const href =
    typeof to === "string" && !isNonLocalizedPath(to)
      ? localizePath(to, i18n.language)
      : to;

  return <Link to={href} {...props} />;
};

export default LocaleLink;
